import {getMessengerClient} from '../utils/messenger'

export const sbUserBlock = blockUserId => {
  return new Promise((resolve, reject) => {
    const sb = getMessengerClient()
    sb.blockUserWithUserId(blockUserId, (user, error) => {
      if (error) {
        reject(error)
      } else {
        resolve(user)
      }
    })
  })
}

export const sbUserUnblock = unblockUserId => {
  return new Promise((resolve, reject) => {
    const sb = getMessengerClient()
    sb.unblockUserWithUserId(unblockUserId, (user, error) => {
      if (error) {
        reject(error)
      } else {
        resolve(user)
      }
    })
  })
}

export const sbCreateBlockedUserListQuery = () => {
  const sb = getMessengerClient()
  return sb.createBlockedUserListQuery()
}

export const sbGetBlockUserList = blockedUserListQuery => {
  return new Promise((resolve, reject) => {
    blockedUserListQuery.next((blockedUsers, error) => {
      if (error) {
        reject(error)
      } else {
        resolve(blockedUsers)
      }
    })
  })
}
